module.exports = __webpack_public_path__ + "static/media/usb-c-gold.bf970ae4.svg";